import * as React from "react";
import { linksOf } from "../../services/cpln";
import { Table } from "../../newcomponents/table/table";
import { TagsColumn } from "../../newcomponents/table/columns/wellKnown/tagsColumn";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { Gvc } from "../../schema/types/gvc/entity";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { Location } from "../../schema/types/location/entity";
import { useListAllGvcsQuery } from "../../store/api/gvcApi";
import { NameDescriptionColumn } from "../../newcomponents/table/columns/wellKnown/nameDescriptionColumn";
import { useParams } from "react-router-dom";

interface Props {
  location: Location;
}
type RouteParams = "org";
export const UsedInGVCs: React.FC<Props> = ({ location }) => {
  const { org: orgName } = useParams<RouteParams>();
  const { data: gvcs, isLoading } = useListAllGvcsQuery(orgName || "", { skip: !orgName });

  const locationLink = linksOf(location).self!;

  const usedGvcs = (gvcs || []).filter((gvc) => gvc.spec?.staticPlacement?.locationLinks?.includes(locationLink));

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <Table<Gvc>
              title={"Used in GVCs"}
              data={usedGvcs}
              isLoading={isLoading}
              tableId={"location-used-in-gvcs"}
              enableFilter
              columns={[NameDescriptionColumn(), TagsColumn(), CreatedColumn(), LastModifiedColumn()]}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
};
